import React from 'react';

import { nameString } from '@evdy/web-core/dist/lib/utils';

import styles from './TeamMemberCTA.module.scss';

import phoneIcon from '../../public/images/icons/phone-icon-navy.svg';
import defaultTeamMemberImg from '../../public/images/default-team-member.png';

const {
  'team-member-container': teamMemberContainerClass,
  title: titleClass,
  description: descriptionClass,
  'contact-btn': contactBtnClass,
  member: memberClass
} = styles;

const TeamMemberCTA = ({
  titleCopy = 'Your Planning Team Member',
  imgSrc = defaultTeamMemberImg,
  name = 'Bryan K.',
  contactNumber = '8774003297',
  description = "Bryan is your personal planning team member and he's here to help with anything you need regarding your package purchase.",
  ctaCopy = 'Contact Bryan',
  customClass
}) => {
  return (
    <div className={`${teamMemberContainerClass} ${customClass}`}>
      <p className={titleClass}>{titleCopy}</p>
      <div className={memberClass}>
        <img src={imgSrc} alt="team-member" />
        <h4>{nameString(name)}</h4>
      </div>
      <p className={descriptionClass}>{description}</p>
      <a href={`tel:${contactNumber}`} className={contactBtnClass}>
        <img src={phoneIcon} alt="phone" />
        {ctaCopy}
      </a>
    </div>
  );
};

export default TeamMemberCTA;
